var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"event"},[_c('TreeNode',{attrs:{"node-data":_vm.nodedatacmp},on:{"checkedchange":_vm.checkedchange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }